export interface RatingCategory {
  key: string;
  label: string;
}

export const RATING_CATEGORIES: RatingCategory[] = [
  { key: 'teamwork', label: 'Teamwork' },
  { key: 'communication', label: 'Communication' },
  { key: 'helpfulness', label: 'Helpfulness' },
  { key: 'reliability', label: 'Reliability' },
];

export interface FeedbackEntry {
  id: number;
  targetId: string;
  targetName: string;
  targetInitials: string;
  avatarColor: string;
  ratings: Record<string, number>;
  feedback: string;
  submittedAt: Date;
}
